/** sessionStorage key for referral code across sign-up → OTP steps */
export const PENDING_REFERRAL_CODE_KEY = "visaro_pending_referral_code";

const MIN_LEN = 6;
const MAX_LEN = 32;

/** Trim, uppercase; returns null if empty after trim */
export function normalizeReferralCodeInput(
  raw: string | null | undefined
): string | null {
  if (raw === undefined || raw === null) return null;
  const t = String(raw).trim();
  if (t === "") return null;
  return t.toUpperCase();
}

/** Core: 6–32 alphanumeric (same namespace as user + campaign codes) */
export function isValidReferralCode(code: string | null | undefined): boolean {
  if (!code) return false;
  if (code.length < MIN_LEN || code.length > MAX_LEN) return false;
  return /^[A-Z0-9]+$/i.test(code);
}

export function getPendingReferralCodeFromStorage(): string | null {
  try {
    const v = sessionStorage.getItem(PENDING_REFERRAL_CODE_KEY);
    const n = normalizeReferralCodeInput(v);
    return n && isValidReferralCode(n) ? n : null;
  } catch {
    return null;
  }
}

export function setPendingReferralCode(code: string | null): void {
  try {
    if (!code) {
      sessionStorage.removeItem(PENDING_REFERRAL_CODE_KEY);
      return;
    }
    sessionStorage.setItem(PENDING_REFERRAL_CODE_KEY, code);
  } catch {
    // ignore
  }
}

export function clearPendingReferralCode(): void {
  setPendingReferralCode(null);
}
